export enum GameName {
  memoryGame = 'memory-game',
  scribble = 'scribble',
}
